'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00241 from "./samples.-Ad-Hoc$package$-Color$1.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00241 from "./samples.-Ad-Hoc$package$-Color$3$$anon$1.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00242 from "./samples.-Ad-Hoc$package$-Color$3$$anon$2.js";
import * as $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00243 from "./samples.-Ad-Hoc$package$-Color$3$$anon$3.js";
var $p;
/** @constructor */
function $c_Lsamples_AdHoc$package$Color$3$(Color$lzy1$7) {
  this.A7 = null;
  this.A8 = null;
  this.KJ = null;
  this.KI = null;
  this.A7 = new $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00241.$c_Lsamples_AdHoc$package$Color$3$$anon$1(Color$lzy1$7, this);
  this.A8 = new $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00242.$c_Lsamples_AdHoc$package$Color$3$$anon$2(Color$lzy1$7, this);
  this.KJ = new $j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00243$0024$0024anon$00243.$c_Lsamples_AdHoc$package$Color$3$$anon$3(Color$lzy1$7, this);
  this.KI = new ($j_samples$002e$002dAd$002dHoc$0024package$0024$002dColor$00241.$d_Lsamples_AdHoc$package$Color$1.r().C)([this.A7, this.A8, this.KJ]);
}
export { $c_Lsamples_AdHoc$package$Color$3$ as $c_Lsamples_AdHoc$package$Color$3$ };
$p = $c_Lsamples_AdHoc$package$Color$3$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_AdHoc$package$Color$3$;
/** @constructor */
function $h_Lsamples_AdHoc$package$Color$3$() {
}
export { $h_Lsamples_AdHoc$package$Color$3$ as $h_Lsamples_AdHoc$package$Color$3$ };
$h_Lsamples_AdHoc$package$Color$3$.prototype = $p;
$p.Yp = (function() {
  return this.KI.x();
});
var $d_Lsamples_AdHoc$package$Color$3$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_AdHoc$package$Color$3$, "samples.AdHoc$package$Color$3$", ({
  oa: 1,
  e: 1,
  aa: 1
}));
export { $d_Lsamples_AdHoc$package$Color$3$ as $d_Lsamples_AdHoc$package$Color$3$ };
